import React, { FC } from "react";
import { TFunction } from "i18next";
import TaskGantt from "../../TaskGantt";
import { CalendarPeriod } from "../calendarPeriod";
import { CalendarEvent } from "../types";
import { GanttToolbar } from "./GanttToolbar";

interface PeriodOption {
  value: CalendarPeriod;
  label: string;
}

interface TaskGanttPanelProps {
  t: TFunction;
  events: CalendarEvent[];
  currentPeriod: CalendarPeriod;
  anchorDate: Date;
  periodOptions: PeriodOption[];
  rangeStart: Date;
  rangeEnd: Date;
  onPeriodChange: (period: CalendarPeriod) => void;
  onAnchorDateChange: (date: Date) => void;
}

export const TaskGanttPanel: FC<TaskGanttPanelProps> = ({
  t,
  events,
  currentPeriod,
  anchorDate,
  periodOptions,
  rangeStart,
  rangeEnd,
  onPeriodChange,
  onAnchorDateChange,
}) => (
  <>
    <GanttToolbar
      t={t}
      currentPeriod={currentPeriod}
      anchorDate={anchorDate}
      periodOptions={periodOptions}
      onPeriodChange={onPeriodChange}
      onAnchorDateChange={onAnchorDateChange}
    />
    <TaskGantt events={events} rangeStart={rangeStart} rangeEnd={rangeEnd} />
  </>
);
